<template>
  <div class="matching-box-horizontal clearfix">
    <table-header
      @add="insertEvent"
      @remove="removeEvent"
      @copy="copyEvent"
      v-if="!isDetail"
    ></table-header>
    <vxe-table
      show-overflow
      keep-source
      border
      ref="xTable"
      class="table-style"
      max-height="320"
      :auto-resize="true"
      :edit-rules="formRules"
      :data="formData"
      :edit-config="{ trigger: 'click', mode: 'cell' }"
    >
      <vxe-table-column
        width="50"
        align="center"
        type="checkbox"
        v-if="!isDetail"
      ></vxe-table-column>
      <vxe-table-column field="procTime" title="付款日期">
        <template v-slot="{ row }">
          <div class="vxe-input--inner" v-if="isDetail">
            {{ row.procTime ? row.procTime.slice(0, 10) : "" }}
          </div>
          <vxe-input
            v-model="row.procTime"
            placeholder="选择日期"
            @change="clearValidate('xTable')"
            type="date"
            transfer
            v-else
          ></vxe-input>
        </template>
      </vxe-table-column>
      <vxe-table-column field="amount" title="付款金额">
        <template v-slot="scope">
          <div class="vxe-input--inner" v-if="isDetail">
            {{ scope.row.amount }}
          </div>
          <vxe-input
            v-model="scope.row.amount"
            placeholder="选填"
            @input="$refs.xTable.updateStatus(scope)"
            @focus="clearValidate('xTable')"
            v-else
          ></vxe-input>
        </template>
      </vxe-table-column>
      <vxe-table-column field="fileList" title="付款凭证" align="center">
        <template v-slot="{ row }">
          <div class="vxe-input--inner" v-if="isDetail">
            <upload-detail :arrList="row.fileList"></upload-detail>
          </div>
          <upload-list
            :row="row"
            :initFileList="row.fileList"
            ref="uploadlistbox"
            :view="'packup'"
            v-else
          ></upload-list>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import TableHeader from "@/components/common/TableHeader";
import UploadList from "@/components/common/UploadList";
import UploadDetail from "@/components/common/UploadDetail";
import { isEmpty, isNotEmpty } from "@/utils/util";
import moment from "moment";
const assign = (o) => Object.assign({}, o);

export default {
  props: {
    isSubmit: Boolean,
    detailData: Object,
    isDetail: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    TableHeader,
    UploadList,
    UploadDetail,
  },
  data() {
    return {
      formData: [],
      formRules: {
        instanceName: [{ required: true, message: "请填写标题" }],
        applyUserName: [{ required: true, message: "请填写申请人" }],
        applyTime: [{ required: true, message: "请选择时间" }],
        type: [{ required: true, message: "请选择类型" }],
      },
      dataTmp: {
        procTime: null,
        amount: null,
      },
      type: "new",
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    isSubmit(val) {
      if (val) {
        this.setParams();
      }
    },
    detailData(val) {
      if (val) {
        let newObj = JSON.parse(JSON.stringify(val))
        if (newObj.payDetailVOS && newObj.payDetailVOS.length > 0) {
          this.formData = newObj.payDetailVOS.map((item) => {
            return Object.assign(item, {
              procTime: item.procTime ? moment(item.procTime).format("YYYY-MM-DD HH:mm:ss") : "",
            });
          });
        }
      }
    },
    // detailData: {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     if (val && val.payDetailVOS && val.payDetailVOS.length > 0) {
    //       this.formData = val.payDetailVOS.map(item => {
    //         return Object.assign(item, {
    //           procTime: item.procTime
    //             ? moment(item.procTime).format("YYYY-MM-DD HH:mm:ss")
    //             : ""
    //         });
    //       });
    //     }
    //   }
    // }
  },
  methods: {
    init() {
      if (this.type === "new") {
        this.insertEvent();
      }
    },
    async setParams() {
      let tableData = this.$refs.xTable.getTableData().tableData;
      let paramsArr = [];
      let flag = true,
        i = 0;
      tableData.forEach((item, index) => {
        let params = {
          fileList: item.fileUuidList,
          procTime: item.procTime ? moment(item.procTime).valueOf() : null,
          amount: item.amount,
        };

        if (
          (isEmpty(params.fileList) && isEmpty(params.procTime) && isEmpty(params.amount)) ||
          (isNotEmpty(params.fileList) && isNotEmpty(params.procTime) && isNotEmpty(params.amount))
        ) {
          if (isNotEmpty(params.fileList)) {
            paramsArr.push(params);
          }
        } else {
          flag = false;
        }
      });
      if (!flag) {
        this.$XModal.message({
          message: "付款信息必须为全为空或者全不为空",
        });
        this.$emit("setParams", false);
        return;
      }
      let obj = {};
      obj.payCreateVOS = paramsArr;
      this.$emit("setParams", obj);
    },
    insertEvent() {
      // 插入货物
      let tableData = this.$refs.xTable.getTableData().tableData;
      this.$refs.xTable.clearValidate();
      let record = assign(this.dataTmp);
      record.index = tableData.length + 1;
      record.fileList = [];
      record.orderPicUUID = [];
      this.$refs.xTable.insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      let confirmRes = await this.$XModal.confirm("删除后不可恢复", "是否删除？");
      if (confirmRes == "confirm") {
        this.$refs.xTable.removeCheckboxRow();
        checkboxRecords.forEach((item) => {
          this.goodDeleteIds.push(item.id);
        });
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      let copyRow = [];
      checkboxRecords.forEach((item) => {
        let paramsObj = {};
        Object.keys(item).forEach((key) => {
          if (key !== "id") {
            paramsObj[key] = item[key];
          }
        });
        copyRow.push(paramsObj);
      });
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      this.$refs.xTable.insertAt(copyRow, -1);
    },
    clearValidate(tableName) {
      let table = this.$refs[tableName];
      table.clearValidate();
    },
  },
};
</script>

<style></style>
